/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, suffix: NonNullable<unknown>, name: NonNullable<unknown> }} Explorer_Thumbnail_Move_TextInputs */

const en_explorer_thumbnail_move_text = /** @type {(inputs: Explorer_Thumbnail_Move_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.count} item${i?.suffix} to "${i?.name}"?`)
};

const fr_explorer_thumbnail_move_text = /** @type {(inputs: Explorer_Thumbnail_Move_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deplacer ${i?.count} element${i?.suffix} vers "${i?.name}" ?`)
};

const de_explorer_thumbnail_move_text = /** @type {(inputs: Explorer_Thumbnail_Move_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verschiebe ${i?.count} item${i?.suffix} nach "${i?.name}"?`)
};

const it_explorer_thumbnail_move_text = /** @type {(inputs: Explorer_Thumbnail_Move_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spostare ${i?.count} elemento${i?.suffix} in "${i?.name}"?`)
};

const ru_explorer_thumbnail_move_text = /** @type {(inputs: Explorer_Thumbnail_Move_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Переместить элемент ${i?.count}${i?.suffix} в "${i?.name}"?`)
};

const es_explorer_thumbnail_move_text = /** @type {(inputs: Explorer_Thumbnail_Move_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Mover el elemento ${i?.count} elemento${i?.suffix} a "${i?.name}"?`)
};

const zh_cn2_explorer_thumbnail_move_text = /** @type {(inputs: Explorer_Thumbnail_Move_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`将 ${i?.count} 项目 ${i?.suffix} 移动到 "${i?.name}"？`)
};

const ja_explorer_thumbnail_move_text = /** @type {(inputs: Explorer_Thumbnail_Move_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} アイテム${i?.suffix} を "${i?.name}" に移動しますか?`)
};

const hi_explorer_thumbnail_move_text = /** @type {(inputs: Explorer_Thumbnail_Move_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} आइटम${i?.suffix} को "${i?.name}" में ले जाएं?`)
};

const pt_pt2_explorer_thumbnail_move_text = /** @type {(inputs: Explorer_Thumbnail_Move_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mover o item __PH_0_ ...`)
};

/**
* | output |
* | --- |
* | "Move {count} item{suffix} to \"{name}\"?" |
*
* @param {Explorer_Thumbnail_Move_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_move_text = /** @type {((inputs: Explorer_Thumbnail_Move_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Move_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_move_text(inputs)
	if (locale === "de") return de_explorer_thumbnail_move_text(inputs)
	if (locale === "it") return it_explorer_thumbnail_move_text(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_move_text(inputs)
	if (locale === "es") return es_explorer_thumbnail_move_text(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_move_text(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_move_text(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_move_text(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_move_text(inputs)
	return en_explorer_thumbnail_move_text(inputs)
});